/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Icon } from '@powdr/components';
import { useStaticData } from '@powdr/web/src/hooks';

import {
  StyledFooterContact, AddressWrapper, Address, Email, PhoneNumber,
} from './styles';

export const FooterContact = () => {
  const {
    footerConfig,
  } = useStaticData();

  return (
    <StyledFooterContact>
      {(footerConfig?.address) && (
        <AddressWrapper>
          <Icon name="content-pin-hollow" height={20} width={20} />
          <Address>
            {`${footerConfig?.address?.streetAddress}, ${footerConfig?.address?.addressLocality}, ${footerConfig?.address?.addressRegion} ${footerConfig?.address?.postalCode}`}
          </Address>
        </AddressWrapper>
        )}
      {(footerConfig?.email) && (
        <Email href={`mailto:${footerConfig.email}`}>
          <Icon name="content-envelope-hollow" height={20} width={20} />
          {footerConfig?.email}
        </Email>
      )}
      {(footerConfig?.phoneNumber) && (
        <PhoneNumber href={`tel:${footerConfig.phoneNumber}`}>
          <Icon name="content-phone" height={20} width={20} />
          {footerConfig.phoneNumber}
        </PhoneNumber>
      )}
    </StyledFooterContact>
  );
};

FooterContact.propTypes = {

};
